import { render, staticRenderFns } from "./CustomerPopUp.vue?vue&type=template&id=7a8f2afc&"
import script from "./CustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./CustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports